import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getContextProviderExtensionPath } from '@wix/cli-astro-definitions';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

const CONTEXT_PROVIDER_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/context-provider'
);

const escapeTsString = (value: string) =>
  value.replaceAll('\\', '\\\\').replaceAll("'", "\\'");

export async function generateContextProvider(
  projectFolder: string,
  folder: string,
  name: string,
  type: string,
  codeIdentifier?: string
) {
  const cwd = getContextProviderExtensionPath(projectFolder, folder);
  const extensionFileName = path.basename(folder);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName,
      codeFileType: 'tsx',
    });

  const config = {
    id: randomUUID(),
    name: escapeTsString(name),
    type: escapeTsString(codeIdentifier ? `${codeIdentifier}.${type}` : type),
    provider: relativePathToCodeFile,
  };
  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCase(folder),
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  return await componentGenerator({
    template: CONTEXT_PROVIDER_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions/experimental'
        : '@wix/astro/builders/experimental',
      route: extensionFileName,
      config,
    },
  });
}
